const CMS_BASE_URL = 'https://api.dev.auxo.dk/public'

/**
 * Optimizes an asset URL with Cloudflare CDN image resizing options.
 */
export function getOptimizedImageUrl(url, width = 800, quality = 80) {
  if (!url || typeof url !== 'string') return ''
  if (url.includes('assets.auxodev.dk') && !url.includes('/cdn-cgi/image/')) {
    return url.replace(
      'https://assets.auxodev.dk/',
      `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
    )
  }
  return url
}

/**
 * Fetches content items from CMS endpoint
 */
export async function fetchCmsItems(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/v2/content/${collectionName}`)
    if (!res.ok) {
      // Fallback to non-v2 if needed
      const resV1 = await fetch(`${CMS_BASE_URL}/content/${collectionName}`)
      if (!resV1.ok) return []
      const dataV1 = await resV1.json()
      return Array.isArray(dataV1) ? dataV1 : []
    }
    const data = await res.json()
    return Array.isArray(data.items) ? data.items : []
  } catch (err) {
    console.warn(`CMS fetch failed for ${collectionName}:`, err)
    return []
  }
}

/**
 * Fetches single item by url_slug or entry id
 */
export async function fetchCmsItemBySlug(collectionName, slug) {
  const items = await fetchCmsItems(collectionName)
  return items.find(
    (item) => item.url_slug === slug || item.id === slug || item.slug?._ === slug
  )
}
